import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICommonStats, IOperatorStats } from "../types/AdminTypes";
import { ITicket, ITicketAdmin } from "../types/TicketTypes";
import { IMessage } from "../types/MessageTypes";

interface IAdminState {
  commonStats: ICommonStats;
  operatorStats: IOperatorStats;
  isLoading: boolean;
  error: string;
  tickets: ITicketAdmin[];
  messages: IMessage[];
}

const initialState: IAdminState = {
  commonStats: {
    total: 0,
    waiting: 0,
    inProgress: 0,
    completed: 0,
    minMark: 0,
    avgMark: 0,
    maxMark: 0,
    date: "",
  },
  operatorStats: {
    acceptedCount: 0,
    avgMark: 0,
    closedCount: 0,
    operator: {
      name: "",
    },
    completedTickets: [],
  },
  tickets: [],
  messages: [],
  error: "",
  isLoading: false,
};

export const adminSlice = createSlice({
  name: "admin",
  initialState,
  reducers: {
    getCommonStatsLoading(state) {
      state.isLoading = true;
      state.error = "";
    },
    getCommonStatsSuccess(state, action: PayloadAction<ICommonStats>) {
      state.isLoading = false;
      state.error = "";
      state.commonStats = action.payload;
    },
    getCommonStatsFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getOperatorStatsLoading(state) {
      state.isLoading = true;
      state.error = "";
    },
    getOperatorStatsSuccess(state, action: PayloadAction<IOperatorStats>) {
      state.isLoading = false;
      state.error = "";
      state.operatorStats = action.payload;
    },
    getOperatorStatsFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getTicketBySearchLoading(state) {
      state.isLoading = true;
      state.error = "";
    },
    getTicketBySearchSuccess(state, action: PayloadAction<ITicketAdmin[]>) {
      state.isLoading = false;
      state.error = "";
      state.tickets = action.payload;
    },
    getTicketBySearchFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getMessageByTicketLoading(state) {
      state.isLoading = true;
      state.error = "";
    },
    getMessageByTicketSuccess(state, action: PayloadAction<IMessage[]>) {
      state.isLoading = false;
      state.error = "";
      state.messages = action.payload;
    },
    getMessageByTicketFailed(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export default adminSlice.reducer;
